export default "__VITE_ASSET__D6d5px0u__"